// extracted by mini-css-extract-plugin
export default {"inputText":"TextInput_inputText__ZCmMU"};